var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep6Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "handshake"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_196",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3570",
    d: "M0 3.8147e-06H54V54H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3576",
    d: "M18.2097 34.3067C19.2831 33.4526 19.4565 31.8788 18.6015 30.8095C17.7434 29.7373 16.1679 29.564 15.0976 30.4182L11.1483 33.5751C10.0749 34.4292 9.90166 36.0062 10.7566 37.0753C11.6116 38.1445 13.1902 38.3208 14.2605 37.4636",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3580",
    d: "M17.3758 41.3519C16.3025 42.2091 16.1291 43.7831 16.9842 44.8522C17.8392 45.9244 19.4177 46.0976 20.4881 45.2434L24.4373 42.0866C25.5106 41.2324 25.684 39.6556 24.8289 38.5863C23.971 37.5172 22.3955 37.3409 21.3251 38.1981",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3584",
    d: "M20.4886 45.2436C19.4183 46.0978 19.2419 47.6747 20.0998 48.7439C20.955 49.813 22.5305 49.9892 23.6037 49.1321L25.8131 47.364C26.8834 46.5099 27.0598 44.9359 26.2047 43.8668C25.3468 42.7946 23.7712 42.6214 22.7009 43.4755",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3588",
    d: "M36.9158 35.2086L39.7381 37.4635C40.8083 38.3207 40.9847 39.8947 40.1297 40.9638C39.2716 42.033 37.696 42.2092 36.6258 41.3521L33.5645 38.9091",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3592",
    d: "M33.5644 38.9092L36.6258 41.3521C37.6961 42.2093 37.8725 43.7833 37.0144 44.8525C36.1594 45.9246 34.5809 46.0978 33.5105 45.2437L30.4521 42.7977",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3596",
    d: "M30.4523 42.7976L31.9801 44.019C33.0504 44.8762 33.2268 46.4502 32.3717 47.5194C31.5137 48.5916 29.9382 48.7648 28.8679 47.9106L26.6436 46.1336",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3600",
    d: "M50.911 25.3827L52.7436 28.6201C53.1681 29.3728 52.902 30.3434 52.1457 30.7616L49.3205 32.3265C48.5641 32.7447 47.6014 32.4819 47.177 31.7322L39.0331 17.3279C38.6056 16.5752 38.8717 15.6075 39.628 15.1895L42.4563 13.6245C43.2126 13.2064 44.1723 13.4663 44.5969 14.2188L46.2501 17.1398",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3604",
    d: "M42.6533 33.4136C43.32 31.9741 44.773 30.9078 46.4412 30.43",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3608",
    d: "M39.7382 37.4634C40.8084 38.3205 42.3869 38.1443 43.242 37.0751C44.0999 36.006 43.9237 34.429 42.8533 33.5749L39.4302 30.8391C37.7679 29.5131 35.8905 28.0437 34.1087 26.7654C30.8858 24.4568 29.2983 22.9217 25.2593 23.734C22.2068 24.3493 19.7374 23.4174 19.0947 20.7743C18.6821 19.0749 20.129 18.2835 22.9962 18.0296L27.5703 17.6204C28.4732 17.5398 29.0113 17.4563 30.4732 17.967L33.2326 18.9316C35.0982 19.5826 34.8471 19.7558 36.7873 19.1944L39.6216 18.3731",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3612",
    d: "M14.3712 15.1895L11.546 13.6245C10.7897 13.2064 9.82701 13.4663 9.4025 14.2189L1.25873 28.6202C0.831158 29.3729 1.09736 30.3435 1.85357 30.7616L4.67887 32.3265C5.43518 32.7447 6.3979 32.4819 6.82242 31.7323L14.9663 17.3279C15.3936 16.5753 15.1277 15.6076 14.3712 15.1895Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3616",
    d: "M19.1035 19.7261L14.3828 18.3583",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3620",
    d: "M11.3485 33.4136C10.6788 31.9741 9.22582 30.9078 7.55762 30.43",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3624",
    d: "M26.999 9.69702V4.32423",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3628",
    d: "M19.9617 11.9221L17.1514 7.46322",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3632",
    d: "M34.04 11.9221L36.8473 7.46322",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3636",
    d: "M14.261 37.4635L19.9503 32.9179C21.0206 32.0638 22.5991 32.24 23.4542 33.3091C24.3092 34.3784 24.1358 35.9524 23.0626 36.8095L17.3762 41.3521C16.303 42.2092 14.7275 42.033 13.8723 40.9638C13.0143 39.8947 13.1908 38.3207 14.261 37.4635Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3640",
    d: "M48.5762 21.2642V21.2611",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6Icon);
export default __webpack_public_path__ + "static/media/step6-icon.ef072fa87fb2cbd005a873dcc199bb2d.svg";
export { ForwardRef as ReactComponent };